export const mappingToMultiViews = (ids, options = [], key) => options.filter(item => ids.includes(item[key]))
export const mappingToAPI = (items, key) => items.map(item => item[key])
